import { CalendarDaysIcon, PlusIcon } from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import styles from '../../styles/testGroupDetail/testGroupLaunchesEmptyPanel.module.scss';

export default function TestGroupSchedulesEmptyPanel({ onCreateSchedule }) {
  const canCreate = typeof onCreateSchedule === 'function';

  return (
    <div className={styles.container}>
      <div className={styles.iconSection}>
        <CalendarDaysIcon className={styles.icon} aria-hidden="true" />
      </div>
      <h3 className={styles.title}>No scheduled launches yet</h3>
      <p className={styles.description}>
        Set up a daily, weekly, or monthly run for this group. Each schedule uses the same type,
        environment, and AI model choices as a one-time launch.
      </p>
      <ButtonComponent
        ctaText="New schedule"
        variant="primary"
        className={`white bg-blue600 ${styles.cta}`}
        startIcon={<PlusIcon className="icon" />}
        onClick={onCreateSchedule}
        disabled={!canCreate}
        size="small"
      />
    </div>
  );
}
